import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Layout from '../Layout';
import { Layout6 } from '../ContentBox';
import {DivHover, DivHelp} from './styled';

class CarouselView extends Component{
  constructor(props){
    super(props);
    this.state = {
      hover: false
    }
  }
  onHover = () => {
    this.setState({hover:true});
  }
  onMouseOver = () => {
    this.setState({hover:false});
  }
  render(){
    return(
      <DivHover onMouseLeave={this.onMouseOver.bind(this)} onMouseEnter={this.onHover.bind(this)}>
        <Layout
        {...this.props} type="CarouselView"></Layout>
        {(this.state.hover)&&(<DivHelp>Content</DivHelp>)}
      </DivHover>
    )
  }
}

CarouselView.propTypes = {
  childOf:PropTypes.string,
  values:PropTypes.object,
  layout:PropTypes.func
};

CarouselView.defaultProps = {
  childOf: 'Content',
  values: {
    parent: 'Content',
    type:'CarouselView',
    altText:'Carousel',
    auto: false,
    direaction: 'incremental',
    interval: 3,
    imageUrl:{
      url:[],
      urlMobile:[]
    }
   },
  layout:Layout6

}
export default CarouselView;



// WEBPACK FOOTER //
// ./src/editor/layout/components/Content/CarouselView.js